import routerOptions0 from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.21.2_@parcel+watcher@2.5.1_@types+node@24.13.2_@vue+compiler-sfc@3.5.30_cac@6.7._b42e231751273cd3927f39ffe47cc7ef/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}